export const IMPORT_ENTITY_TYPE = {
  MODELS: "models",
  AGENCIES: "agencies",
  CLIENTS: "clients",
}
